var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"ds-button",class:{
    secondary: _vm.secondary,
    destructive: _vm.destructive,
    filled: _vm.filled,
    dark: _vm.dark,
    disabled: _vm.disabled,
    raised: _vm.raised,
  },attrs:{"disabled":_vm.disabled}},_vm.$listeners),[(_vm.prependIcon)?_c('v-icon',{staticClass:"ds-button-icon",attrs:{"size":"24"},domProps:{"textContent":_vm._s(_vm.prependIcon)}}):_vm._e(),_c('span',{staticClass:"ds-button-content"},[_vm._t("default")],2),(_vm.icon)?_c('v-icon',{staticClass:"ds-button-icon",attrs:{"size":"24"},domProps:{"textContent":_vm._s(_vm.icon)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }